
import {Component, Mixins, Prop} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {VekaletUcretDonemEntity} from "@/entity/VekaletUcretDonemEntity";
import MuvekkilVekaletUcretleriForm from "@/components/forms/MuvekkilVekaletUcretleriForm.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {VekaletEntity} from "@/entity/VekaletEntity";
import TutarAraligiForm from "@/components/forms/TutarAraligiForm.vue";

@Component({
  components: {TutarAraligiForm, MuvekkilVekaletUcretleriForm, FormDialog, DeleteDialog},
})
export default class MuvekkilVekaletUcretleriList extends Mixins(ObjectInputMixin) {
  @Prop() vekalet!: any;

  items: VekaletUcretDonemEntity[] = [];
  selectedItem: any ={};
  headers = [
    {text: "Alt Sınır", value: "alt_sinir", align: "start"},
    {text: "Üst Sınır", value: "ust_sinir", align: "start"},
    {text: "Oran", value: "muvekkil_oran", align: "start"},
    {text: "Tutar", value: "standart_ucret", align: "start"},
    {text: "İşlemler", value: "actions", width: "100", align: "end", sortable: false}
  ];

  load() {
    this.$emit("load");
  }

}
